import "core-js/modules/es.array.push.js";
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "table-page-cnt"
};
const _hoisted_2 = {
  key: 0,
  class: "tb-pg-toolbar"
};
const _hoisted_3 = {
  key: 1,
  class: "table-page-header"
};
const _hoisted_4 = {
  key: 2,
  class: "tb-pg-searchbar"
};
import { computed, reactive, ref, toRefs } from 'vue';
import { XTable, XToolbar } from '@/components';
const __default__ = {
  name: 'XTableLayout'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    toolbar: {
      type: Array,
      default: () => []
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    showTable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: [Object, Boolean],
      default: false
    },
    rowSelection: {
      type: Object
    },
    total: {
      type: Number,
      default: 0
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 50
    },
    configKey: {
      type: String,
      default: ''
    },
    selectHighlight: {
      type: Boolean,
      default: true
    },
    contentStyle: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['toolbar-item-click', 'table-change', 'row-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      selectHighlight
    } = toRefs(props);
    const emit = __emit;
    const queryOrder = ref([]); // 排序条件

    const formatTotal = (total, range) => `${range[0]} - ${range[1]} 条/共 ${total} 条`;
    const paginationOptions = reactive({
      position: ['bottomCenter'],
      defaultPageSize: 50,
      pageSizeOptions: ['10', '20', '50', '100'],
      showSizeChanger: true,
      showQuickJumper: false,
      responsive: true,
      size: 'large',
      showTotal: formatTotal
    });
    const dataSource = computed(() => {
      if (!props.rows || props.rows.length === 0) {
        return [];
      }
      return props.rows;
    });
    const handleChange = (pagination, filters, sorter) => {
      const {
        current: pi = 1,
        pageSize: ps = 50
      } = pagination || {};
      const sqlOrders = {
        ascend: 'asc',
        descend: 'desc'
      };
      if (Array.isArray(sorter)) {
        const sortList = [];
        for (const item of sorter) {
          const {
            field,
            order
          } = item || {};
          if (!field || !order) continue;
          sortList.push(`${field} ${sqlOrders[order]}`);
        }
        queryOrder.value = sortList;
      } else if (typeof sorter === 'object') {
        const {
          field,
          order
        } = sorter || {};
        if (field && order) {
          queryOrder.value = [`${field} ${sqlOrders[order]}`];
        } else {
          queryOrder.value = [];
        }
      }
      emit('table-change', {
        pageIndex: pi,
        pageSize: ps,
        order: queryOrder.value
      });
    };
    const toolbarItems = computed(() => props.toolbar);

    // 表格分页配置
    const tablePagination = computed(() => {
      if (typeof props.pagination === 'boolean' && props.pagination) {
        return {
          ...paginationOptions,
          total: props.total,
          pageSize: props.pageSize,
          current: props.pageIndex
        };
      } else if (typeof props.pagination === 'object') {
        return props.pagination;
      }
      return false;
    });
    const selectKey = ref('');
    const handleRowClick = (record, index) => {
      selectKey.value = record[props.rowKey] || '';
      emit('row-click', record, index);
    };
    const rowClassName = (record, index) => {
      if (!selectHighlight.value) return '';
      const currentKey = record[props.rowKey] || '';
      if (currentKey === selectKey.value) {
        return 'x-table-current-row';
      } else {
        return index % 2 === 0 ? 'x-table-even-row' : 'x-table-odd-row';
      }
    };
    const handleToolbarItemClick = item => {
      emit('toolbar-item-click', item);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.showToolbar ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "toolbar", {}, () => [_createVNode(_unref(XToolbar), {
        items: toolbarItems.value,
        onItemClick: handleToolbarItemClick
      }, null, 8, ["items"])])])) : _createCommentVNode("", true), _ctx.$slots.header ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "header")])) : _createCommentVNode("", true), _ctx.$slots.searchbar ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "searchbar")])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "tb-pg-content x-table-layout",
        style: _normalizeStyle(__props.contentStyle)
      }, [__props.showTable ? _renderSlot(_ctx.$slots, "table", {
        key: 0
      }, () => [_createVNode(_unref(XTable), _mergeProps({
        loading: __props.loading,
        "data-source": dataSource.value,
        rowKey: __props.rowKey,
        columns: __props.columns,
        pagination: tablePagination.value,
        rowClassName: rowClassName,
        "config-key": __props.configKey,
        "row-selection": __props.rowSelection
      }, _ctx.$attrs, {
        onChange: handleChange,
        onRowClick: handleRowClick
      }), _createSlots({
        _: 2
      }, [_renderList(_ctx.$slots, (_, key) => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))])
        };
      })]), 1040, ["loading", "data-source", "rowKey", "columns", "pagination", "config-key", "row-selection"])]) : _renderSlot(_ctx.$slots, "content", {
        key: 1
      })], 4)]);
    };
  }
});